var core = module.exports = {};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.core.js
 ** module id = 26
 ** module chunks = 0
 **/